import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=01404cb6&scoped=true&"
import script from "./Estoque.vue?vue&type=script&lang=js&"
export * from "./Estoque.vue?vue&type=script&lang=js&"
import style0 from "./Estoque.vue?vue&type=style&index=0&id=01404cb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01404cb6",
  null
  
)

export default component.exports